import styled from 'styled-components';

/* O layout padrão envolve a página num div sem altura, então `height: 100%` não
   resolve — daí a altura em viewport, que independe do pai. */
const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 0;
`;

const Image = styled.img`
  position: absolute;
  bottom: 0;
  width: 100vw;
  object-fit: cover;
`;

const BlueEllipse = styled.div`
  background-color: var(--primary-color);
  position: absolute;
  bottom: 50%;
  left: 50%;
  transform: translate(-50%, 85%);
  width: 120%;
  height: 70%;
  border-top-left-radius: 50%;
  border-top-right-radius: 50%;
`;

const FormContainer = styled.main`
  /* Centralizado pelo flex do Container, e não por um margin-top calculado: esta
     tela muda de altura entre o formulário e a confirmação de envio. */
  z-index: 10;
  background-color: white;
  width: 43rem;
  min-height: 38rem;
  border-radius: 20px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.11);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem 7rem;

  form {
    width: 100%;

    button {
      margin: 3rem auto 0 auto;
    }
  }
`;

const Logo = styled.img`
  width: 15rem;
  margin-bottom: 2rem;
`;

const Title = styled.h1`
  color: var(--font-color);
  font-size: 2rem;
  margin-bottom: 1rem;
  text-align: center;
`;

const Description = styled.p`
  color: var(--font-color);
  font-size: 1.4rem;
  line-height: 2rem;
  margin-bottom: 2rem;
  text-align: center;
`;

const BackLink = styled.button`
  background: none;
  border: none;
  color: var(--primary-color);
  cursor: pointer;
  display: inline-block;
  font-size: 1.4rem;
  font-weight: 600;
  margin-top: 2rem;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export {
  Container,
  Image,
  BlueEllipse,
  FormContainer,
  Logo,
  Title,
  Description,
  BackLink,
};
